import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";
import { withStyleProps } from "Utils/styleProps";

const Header = ({ inline, level, styLevel, classes, color, className: additionalClassName, children, ...rest }) => {
  const className = classnames(
    "CobaltHeader",
    `CobaltHeader--h${styLevel || level}`,
    {
      "CobaltHeader--inline": inline,
      [`CobaltHeader--${color}`]: !!color,
    },
    classes,
    additionalClassName,
  );
  const element = React.createElement(
    `h${Math.min(level, 6)}`,
    {
      className,
      ...rest,
    },
    [children],
  );
  return element;
};

Header.propTypes = {
  inline: PropTypes.bool,
  level: PropTypes.number,
  styLevel: PropTypes.number,
  color: PropTypes.oneOf(["error", "warning", "success", "muted", "white"]),
  className: PropTypes.string,
  children: PropTypes.node,
};
// TODO(UI/Header fix) remove this. It is implying context rules.
const defaultStyleProps = {
  mb: 2,
};

const makeHeader = (level) => {
  const component = (rest) =>
    Header({
      level,
      ...rest,
    });

  return withStyleProps(component, defaultStyleProps);
};

export const H1 = makeHeader(1);
export const H2 = makeHeader(2);
export const H3 = makeHeader(3);
export const H4 = makeHeader(4);
export const H5 = makeHeader(5);
export const Title = makeHeader(6);
export const Subtitle = makeHeader(7);
export default withStyleProps(Header, defaultStyleProps);
